import React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import { useIntl } from 'react-intl';

import { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { cpfMask } from '@/utils/mask/commonMasks';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';
import validateCpf from '@/utils/functions/validateCpf';

interface CpfFormFieldProps extends Omit<MaskedInputProps, 'mask'> {
  label?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  fieldName?: NamePath;
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  initialValue?: string;
  required?: boolean;
  disabled?: boolean;
  notRequired?: boolean;
}

const CpfFormField: React.FC<CpfFormFieldProps> = ({
  onChange,
  initialValue,
  fieldName = 'cpf',
  label = 'CPF',
  requiredRuleTextId = 'commons.form.errors.requiredCpf',
  lengthRuleTextId = 'commons.form.errors.invalidCpf',
  required = true,
  disabled,
  notRequired,
}) => {
  const intl = useIntl();

  const rules: Rule[] = [
    {
      min: 11,
      max: 11,
      validator: async (rule, value) => {
        if (value) {
          return Promise.all([
            maskFieldValidator(rule, value),
            value.length == rule.max
              ? validateCpf(value)
                ? Promise.resolve()
                : Promise.reject(new Error('CPF inválido'))
              : Promise.resolve(),
          ]);
        }
      },
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  if (required) {
    rules.push({
      required: true,
      message: intl.formatMessage({ id: requiredRuleTextId }),
    });
  }

  return (
    <FloatingFormItem
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={removeMaskFromEvent}
      rules={!notRequired ? rules : undefined}
    >
      <MaskedInput
        disabled={disabled}
        className="ant-input"
        mask={cpfMask}
        onChange={onChange}
      />
    </FloatingFormItem>
  );
};

export default CpfFormField;
